import React from 'react';
import SmsShare from './components/Sms';
import EmailShare from './components/Email';
import { put_api } from '../../../../../../redux/api_funcs';
import { get_api_url } from '../../../../../../utils/urls.js';

interface SharePlanProps {
  smsContent: string;
  emailSubject: string;
  emailContent: string;
  studentDetails: {
    email: string;
    student_uuid: string;
    last_name: string;
    first_name: string;
    message_dispatch_method: string;
    is_allowed_whatsapp: boolean;
    is_allowed_sms: boolean;
  };
  personalisedData: {
    is_sms_sent: boolean;
    is_email_sent: boolean;
  };
}

const SharePlanModal: React.FC<SharePlanProps> = ({
  smsContent,
  emailSubject,
  emailContent,
  studentDetails,
  personalisedData
}) => {
  const isSmsAllowed = studentDetails.message_dispatch_method === 'sms';
  const isWhatsappAllowed = studentDetails.message_dispatch_method === 'whatsapp';
  const updateShareStatus = async (medium: 'sms' | 'email') => {
    const url = `/v2/cms_user/students/${studentDetails.student_uuid}/personalised_plans/shared/${medium}`;
    try {
      const apiUrl = get_api_url(url, false, true);
      await put_api(apiUrl, false, true);
    } catch (error) {
      console.error('Error updating share status:', error);
    }
  };

  const renderMessageBtn = () => {
    const { is_allowed_sms, is_allowed_whatsapp } = studentDetails;
    const channels = [];

    if (is_allowed_sms) channels.push('SMS');
    if (is_allowed_whatsapp) channels.push('WhatsApp');

    if (channels.length === 0) return null;

    return `Send ${channels.join(' / ')}`;
  };

  return (
    <>
      <div className="w-full max-w-[1000px] mx-auto bg-white rounded-2xl pb-6 md:pb-8 md:px-[20px]">
        <h2 className="font-semibold text-[#333] text-[19px] leading-[22px]">
          Personalised Plan Saved!
        </h2>
        <p className="text-[#939393] text-[14.5px] font-medium leading-[26px] mb-[20px] mt-[5px]">
          Now, select how to share this plan with the user
        </p>
        <div className="flex gap-6">
          <SmsShare
            smsContent={smsContent}
            btnText={() => renderMessageBtn()}
            studentDetails={studentDetails}
            title={renderMessageBtn()}
            onSend={() => updateShareStatus('sms')}
            isSmsSent={personalisedData?.is_sms_sent}
          />
          <EmailShare
            emailSubject={emailSubject}
            emailContent={emailContent}
            email={studentDetails.email}
            onSend={() => updateShareStatus('email')}
            isEmailSent={personalisedData?.is_email_sent}
          />
        </div>
        {!isSmsAllowed && !isWhatsappAllowed && (
          <p className="text-[#FF2121] md:text-[15.5px] zm:text-[12.5px] font-medium my-[10px]">
            No communication method (SMS/WhatsApp) is enabled for this user. Please update their
            preferences.
          </p>
        )}
      </div>
    </>
  );
};

export default SharePlanModal;
